export default __webpack_public_path__ + "static/media/Microsoft-icon.40579e8d.svg";